import { createAction } from "@reduxjs/toolkit";

const updateUploadProgress = createAction<{ id: string; progress: number }>(
  "uploads/updateProgress"
);

export default updateUploadProgress;
